import LandingPage from "../LandingPage.jsx";

export default function LandingIt() {
  return <LandingPage forcedLang="it" />;
}